module.exports = __webpack_public_path__ + "assets/media/leo-strupczewski-dark.c319ec48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/TreeringTestimonial/leo-strupczewski-dark.svg
// module id = 2031
// module chunks = 0